import React, { FC } from "react"
import { MultiPathSVG } from "components/views/SVG"
import styled from "styled-components"
import { Spacer } from "components/views/atoms/Atoms"
import { BodySmall } from "components/views/atoms/Bodies"
import { StylelessButton } from "components/views/molecules/Molecules"
import { useToggle } from "utils/Hooks"
import { HowMuchReimbursedModalContainer } from "components/containers/reimbursements/educationmodal/HowMuchReimbursedModalContainer"

const Badge = styled.div`
  align-self: flex-start;
  padding: 2px 6px;
  border-radius: 4px;
`

type PlanInfoBadgeProps = {
  backgroundColor: string
  fontColor: string
}

const PlanInfoBadge: FC<PlanInfoBadgeProps> = ({ backgroundColor, fontColor, children }) => {
  const [showHowMuchReimbursedModal, toggleHowMuchReimbursedModal] = useToggle()

  return (
    <>
      <Badge className={`bg-${backgroundColor} lh-copy f6 inline-flex`}>
        <BodySmall color={fontColor}>{children}</BodySmall>
        <Spacer width={0.25} />
        <StylelessButton onClick={toggleHowMuchReimbursedModal}>
          <MultiPathSVG iconName="icn-help" />
        </StylelessButton>
      </Badge>
      {showHowMuchReimbursedModal && <HowMuchReimbursedModalContainer onExit={toggleHowMuchReimbursedModal} />}
    </>
  )
}

export { PlanInfoBadge }
